import React, {useEffect, useRef, useState} from 'react';
import DialogMUI from '../../../shared/DialogMUI';
import {useDispatch, useSelector} from 'react-redux';
import {closeModal} from '../../../redux/actions/app/appActions';
import {ReactComponent as CloseSvg} from '../../../assets/icons/close.svg';

import './VideoPopup.scss';
import {useTranslation} from 'react-i18next';
import {POPUPS} from "../../../redux/actions/app/appActionTypes";
import {getChatMessage} from "../../../redux/actions/projects/projectsActions";
import {LoaderMUI} from "../../../shared";

const VideoPopup = () => {
    const dispatch = useDispatch();
    const videoRef = useRef(null);
    const {t} = useTranslation();
    const additionalPopupShow = useSelector(({app}) => app.popupToShow);
    const popupData = useSelector(({app}) => app.popupToShowData);
    const [videoUrl, setVideoUrl] = useState('');
    const popupVisible = additionalPopupShow === POPUPS.VIDEO_POPUP;

    const onCloseHandler = () => {
        if (videoUrl) {
            URL.revokeObjectURL(videoUrl);
        }
        setVideoUrl('')
        dispatch(closeModal())
    }

    useEffect(() => {
        const fetchVideo = async () => {
            if (popupData?.projectId && popupData.chatId && popupData.id) {
                try {
                    const res = await dispatch(getChatMessage(popupData?.projectId, popupData.chatId, popupData.id));
                    const video = res?.payload?.data?.data?.videos[popupData?.indexVideo].path;
                    const response = await fetch(video);

                    const blob = await response.blob();
                    const objectURL = URL.createObjectURL(blob);

                    setVideoUrl(objectURL);
                } catch (e) {
                    onCloseHandler()
                }
            } else {
                onCloseHandler()
            }


        }
        if (popupVisible && popupData && Object.keys(popupData)?.length > 0) {
            fetchVideo()
        } else {
            onCloseHandler();
        }
    }, [popupVisible]);
    return (
        <div className={'dialogVideo'}>
            <DialogMUI
                withoutDefaultWrapper={true}
                className={'mui-withoutBg dialogVideos'}
                fullScreen={true}
                maxWidth={'lg'}
                open={popupVisible} onClose={onCloseHandler} title={t('all.viewVideo')}
                fullWidth={true}>
                <div className={'videoMainContainer'}>
                    <div
                        className='dialog-mui__close'
                        onClick={onCloseHandler}
                    >
                        <CloseSvg/>
                    </div>
                    {!videoUrl ? <div className={'videoContainer'}>
                            <LoaderMUI noBg={true} staticPos={true}
                                       circleSize={40}/>
                        </div> :
                        <div className="video">
                            <video playsInline={true} ref={videoRef} src={videoUrl} controls={true}
                                   autoPlay={true}></video>
                        </div>

                    }
                </div>
            </DialogMUI>
        </div>
    );
};

export default VideoPopup;
